import { Link } from "react-router-dom";
import { Button } from "rsuite";
import { AppRoutesUI } from "../../config/appRoutes";

export const AddAdminsButton = () => {
  return (
    <Link to={AppRoutesUI.Admins.AdminAdd()}>
      <Button className="listPage-add-button" appearance="primary" size="md">
        Add New Admin
      </Button>
    </Link>
  );
};
